import axios from "axios";
import "dotenv/config";
import { generateToken } from "./jwtVerify";
axios.interceptors.request.use(
  (config) => {
    config.headers["token"] = generateToken();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export const AxiosExpress = axios.create();

export const AxiosAuth = axios.create({
  baseURL: process.env.BASE_URL_AUTH,
});

export const AxiosClient = axios.create({
  baseURL: process.env.BASE_URL_CLIENT ,
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
});
export const AxiosServer=axios.create({
  baseURL: "https://mediahub.tuoitre.vn/eduzone",
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
})
export const AxiosClientServerNuxt = axios.create({
  baseURL: process.env.BASE_URL_CLIENT,
  headers: {
    token: generateToken(),
  },
});

AxiosClientServerNuxt.interceptors.request.use(
  (config) => {
    config.headers["token"] = generateToken();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const AxiosUpload = axios.create({
  baseURL: process.env.BASE_URL_UPLOAD ||"https://res-eduzone.tuoitre.vn"|| "https://ts-res-staging.tuoitre.vn",
});
